<div class="relative">
  <app-transaction-timer class="block absolute right-2 top-2" />
</div>

<main class="flex justify-center items-center pt-8 min-h-screen w-full relative">
    <router-outlet />
</main>
<p-toast [breakpoints]="{ '530px': { width: '90%', right: '0', left: '0', margin: 'auto' } }" />
